import script from "./MyProjects.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjects.vue?vue&type=script&lang=ts&setup=true"

import "./MyProjects.vue?vue&type=style&index=0&id=76ac40be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ac40be"]])

export default __exports__